(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["peptiva-delivery-preview"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('peptiva-delivery-preview')){
customElements.define('peptiva-delivery-preview',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const select=this.querySelector('select');const update=()=>{const group=select.selectedOptions[0].dataset.group;this.querySelectorAll('[data-delivery-panel]').forEach(panel=>panel.hidden=panel.dataset.deliveryPanel!==group)};select.addEventListener('change',update);update()}
})}
  } catch(e) { console.error(e); }
})();

})();
